'use es6';

import PropTypes from 'prop-types';
import { useState, useCallback, useEffect, useRef } from 'react';
import TableFloatyPopoverBody from 'rich-text-lib/components/table/TableFloatyPopoverBody';
import { isResponsiveTableNode } from '../utils/table';
import SimpleFloaty from './SimpleFloaty';
import { useTinyMcePopoverLifecycle } from '../hooks/useTinyMcePopoverLifecycle';
import { flip, hide } from '@floating-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
const removeMceSelectedAttr = tableNode => {
  tableNode.parentNode.removeAttribute('data-mce-selected');
};
const propTypes = {
  editor: PropTypes.object.isRequired,
  eventKey: PropTypes.string.isRequired,
  onCloneTable: PropTypes.func.isRequired,
  onDeleteTable: PropTypes.func.isRequired
};
function TablePopoverManagerV2(props) {
  var _document$querySelect;
  const {
    editor,
    eventKey,
    onCloneTable,
    onDeleteTable
  } = props;
  const [target, setTarget] = useState(null);
  const [refreshKey, setRefreshKey] = useState('');
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    const lastTableEl = lastTarget.current;
    if (lastTableEl) {
      if (isResponsiveTableNode(lastTableEl)) {
        removeMceSelectedAttr(lastTableEl);
      }
      setTarget(null);
    }
  }, []);
  const handleNodeChange = useCallback(({
    element
  }) => {
    if (!element) {
      handleRemove();
      return;
    }
    const lastTableEl = lastTarget.current;
    if (lastTableEl !== element) {
      if (lastTableEl && isResponsiveTableNode(lastTableEl)) {
        removeMceSelectedAttr(lastTableEl);
      }
      setTarget(element);
    } else {
      // We need this dummy prop to force a re-render so tether updates
      // after alignment and dimension changes
      const wrapper = isResponsiveTableNode(element) ? element.parentNode : element;
      setRefreshKey(wrapper.outerHTML);
    }
    if (isResponsiveTableNode(element)) {
      element.parentNode.setAttribute('data-mce-selected', '2');
    }
  }, [handleRemove, lastTarget]);
  useTinyMcePopoverLifecycle({
    editor,
    onRemove: handleRemove,
    onNodeChange: handleNodeChange,
    eventKey
  });
  const handleSelectTable = () => {
    editor.selection.select(target);
  };
  const handleOpenStart = () => {
    // Select table node if not already selected
    if (editor.selection.getNode() !== target) {
      handleSelectTable();
    }
  };
  if (!target) return null;
  const toolbarBoundary = (_document$querySelect = document.querySelector('[data-test-id="canvas-toolbar"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect();
  const toolbarHeight = toolbarBoundary.height;
  return /*#__PURE__*/_jsx(SimpleFloaty, {
    "data-test-id": "table-selector-popover",
    target: target,
    placement: "top-start",
    middleware: editor.settings.inline ? [flip({
      padding: toolbarHeight
    }), hide({
      padding: toolbarHeight
    })] : [],
    refreshKey: refreshKey,
    children: /*#__PURE__*/_jsx(TableFloatyPopoverBody, {
      onOpenStart: handleOpenStart,
      onSelectTable: handleSelectTable,
      onCloneTable: onCloneTable.bind(null, target),
      onDeleteTable: onDeleteTable.bind(null, target)
    })
  });
}
TablePopoverManagerV2.propTypes = propTypes;
export default TablePopoverManagerV2;